var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWideWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    viewBox: "0 0 904 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.05
    },
    d: "m 360.4783,381.39239 c -7.7,-4.26785 -24.57531,-13.46834 -37.50068,-20.44554 l -23.50068,-12.68582 -14.99932,3.20226 c -20.90459,4.46301 -52.78443,5.37566 -71.42674,2.04478 -51.66142,-9.23046 -82.22791,-39.36706 -92.96655,-91.65902 -2.36903,-11.53603 -2.6578,-17.53484 -2.1575,-44.81868 0.53634,-29.24894 0.84559,-32.38007 4.32732,-43.81522 12.0387,-39.53906 35.50149,-64.29339 71.68189,-75.627725 15.27736,-4.785984 29.41994,-6.557061 52.36018,-6.557061 22.5269,0 38.16279,2.402505 55.55172,8.535702 49.56383,17.481504 85.12689,53.936324 95.71903,98.119254 3.52179,14.69041 3.75368,37.74914 0.52248,51.9556 -4.71439,20.72761 -16.09061,42.01016 -31.8006,59.49237 -4.3508,4.8416 -7.91055,9.17223 -7.91055,9.62361 0,0.45138 4.095,15.78445 9.1,34.07347 9.34326,34.1417 9.84942,36.42793 8.05,36.36087 -0.5775,-0.0215 -7.35,-3.531 -15.05,-7.79885 z m -149.66,-148.12202 c 6.34517,-6.34516 6.58525,-13.23014 0.66769,-19.1477 -4.6654,-4.6654 -10.43541,-5.33925 -16.93571,-1.97781 -8.35773,4.32195 -9.62848,14.61363 -2.66429,21.57782 6.09537,6.09537 12.53856,5.94143 18.93231,-0.45231 z m 53.78802,2.64551 c 5.08573,-2.62993 6.97198,-6.03915 6.97198,-12.60117 0,-6.70439 -6.22208,-13.28434 -12.56183,-13.28434 -14.23025,0 -20.31782,15.46712 -9.62783,24.46216 4.80101,4.03978 9.33753,4.46409 15.21768,1.42335 z m 56,0 c 5.08573,-2.62993 6.97198,-6.03915 6.97198,-12.60117 0,-6.94406 -6.20625,-13.28434 -13.00351,-13.28434 -13.08819,0 -18.82908,16.97957 -8.49049,25.11192 4.35447,3.42522 8.92365,3.66862 14.52202,0.77359 z M 55.278295,272.48581 C 45.011901,269.9831 31.58355,262.3171 25.049933,255.22896 15.843436,245.24108 12.093287,235.48292 11.445943,219.83037 10.812655,204.51768 13.2781,195.11279 21.584797,181.15383 25.317894,174.88055 27.168883,169.27828 29.389969,157.53037 36.874613,117.94212 51.155141,89.898779 76.586751,64.847837 100.14664,41.640601 129.67384,25.452908 162.99379,17.476894 249.1705,-3.1517864 335.84327,35.552449 373.01298,111.26222 c 3.42069,6.96748 6.66494,15.17761 7.20945,18.24472 l 0.99001,5.57658 -8.26707,-7.20178 c -4.54688,-3.96098 -10.47207,-9.52631 -13.16707,-12.36742 -6.51107,-6.86408 -17.68355,-14.39147 -32.15456,-21.663918 -6.52001,-3.276641 -15.34001,-8.936823 -19.59999,-12.57816 C 297.6091,72.370048 289.8635,67.294085 276.31214,60.490484 253.54091,49.057948 234.99616,44.719148 208.98913,44.739308 143.31313,44.790228 89.231853,81.785566 68.031954,141.1638 c -2.009513,5.62839 -3.653658,10.5984 -3.653658,11.04445 0,0.44605 3.923746,0.45521 8.719436,0.0204 4.79569,-0.43486 11.688081,-0.43906 15.316426,-0.009 l 6.596989,0.78131 -0.229515,59.88252 -0.229517,59.88252 -4.93691,0.81696 c -8.064126,1.33456 -26.821415,0.73542 -34.33691,-1.09667 z",
    id: "path6"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "73.409px",
      textAlign: "start",
      writingMode: "lr-tb",
      direction: "ltr",
      textAnchor: "start",
      whiteSpace: "pre",
      inlineSize: 468.583,
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1
    },
    x: 451.03625,
    y: 94.613922,
    id: "text8",
    transform: "matrix(1.310818,0,0,1.3046711,-125.90575,62.53324)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 451.03625,
    y: 94.613922,
    id: "tspan6"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontWeight: "bold",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Bold'"
    },
    id: "tspan5"
  }, "CUSTOM\n")), /*#__PURE__*/React.createElement("tspan", {
    x: 451.03625,
    y: 187.22495,
    id: "tspan8"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontWeight: "bold",
      fontFamily: "Arial",
      InkscapeFontSpecification: "'Arial Bold'"
    },
    id: "tspan7"
  }, "ANSWER")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWideWhite);
export default __webpack_public_path__ + "static/media/logo-wide-white.aa70524303bde35a9521f0017516e2cc.svg";
export { ForwardRef as ReactComponent };